import { isObjectEmpty } from '../../../utils/object-utils';
import {
  STOPPED,
  LAUNCH_FAILED,
  DESTROY_FAILED,
  LAUNCHING,
  RUNNING,
  DESTROYING,
  SCALE_DOWN,
  SCALE_UP_FAILED,
  SCALE_DOWN_FAILED,
  SCALING_UP,
  SCALING_DOWN,
} from '../../../constants/deployments';

const buttonIdTooltipMap = {
  destroy: 'Destroy the Environment',
  'scale-up':
    'Scales up deployments and statefulsets, and enables cronjobs in the cluster.',
  'scale-down':
    'Scales down deployments and statefulsets, and disables cronjobs in the cluster',
};

export const getReleasePageVisibility = ({ clusterState, clusterDetails }) => {
  const isReleasePaused = clusterDetails?.pauseReleases;
  let showLaunch = [STOPPED, LAUNCH_FAILED]?.includes(clusterState);

  let showDestroy = [
    // RUNNING,
    LAUNCH_FAILED,
    DESTROY_FAILED,
    // SCALE_DOWN,
    // SCALE_UP_FAILED,
    // SCALE_DOWN_FAILED,
  ]?.includes(clusterState);

  let showRelease = clusterState === RUNNING;

  let showPauseRelease = !isObjectEmpty(clusterDetails) && !isReleasePaused;

  let showResumeRelease = !isObjectEmpty(clusterDetails) && isReleasePaused;

  let showScaleUp = [SCALE_DOWN, SCALE_UP_FAILED, SCALE_DOWN_FAILED].includes(
    clusterState,
  );

  let showScaleDown = [RUNNING, SCALE_UP_FAILED, SCALE_DOWN_FAILED].includes(
    clusterState,
  );

  let showUpdateTf = true;
  let showReleaseSchedule = true;
  let showUnlockState = true;
  let showValidations = true;

  return {
    launch: showLaunch,
    destroy: showDestroy,
    release: showRelease,
    'scale-up': showScaleUp,
    'scale-down': showScaleDown,
    'pause-release': showPauseRelease,
    'resume-release': !!showResumeRelease,
    'update-tf': showUpdateTf,
    'release-schedule': showReleaseSchedule,
    'unlock-state': showUnlockState,
    validations: showValidations,
    'terraform-export': true,
  };
};

export const getDisableStatusForActions = ({
  clusterState,
  clusterDetails,
  tfVersionMap,
  pendingMigrationsOverview,
  cpSetting,
}) => {
  const scaleUpInprogress = clusterState === SCALING_UP;
  const scaleDownInProgress = clusterState === SCALING_DOWN;

  const isReleasePaused = clusterDetails?.pauseReleases;
  const isPartiallyRun = pendingMigrationsOverview?.blockReleases;

  const disableLaunch =
    isObjectEmpty(clusterDetails) ||
    clusterState === LAUNCHING ||
    isReleasePaused;

  const disableDestroy =
    isObjectEmpty(clusterDetails) ||
    clusterState === DESTROYING ||
    isReleasePaused ||
    scaleUpInprogress ||
    scaleDownInProgress;

  const disableRelease =
    isObjectEmpty(clusterDetails) ||
    isReleasePaused ||
    scaleUpInprogress ||
    scaleDownInProgress;

  const disableScaleUp =
    isObjectEmpty(clusterDetails) ||
    clusterDetails?.baseClusterId?.length > 0 ||
    isReleasePaused ||
    scaleUpInprogress ||
    scaleDownInProgress;

  const disableScaleDown =
    isObjectEmpty(clusterDetails) ||
    clusterDetails?.baseClusterId?.length > 0 ||
    isReleasePaused ||
    scaleUpInprogress ||
    scaleDownInProgress ||
    isPartiallyRun;

  const disableTerraformExport = !cpSetting?.['TERRAFORM_EXPORT_ENABLE'];
  const disableUpdateTf = !tfVersionMap?.version;
  const disablePauseRelease = false;
  const disableResumeRelease = false;
  const disableReleaseSchedule = false;
  const disableUnlockState = false;
  const validationsState = false;

  return {
    launch: disableLaunch,
    destroy: disableDestroy,
    release: disableRelease,
    'scale-up': disableScaleUp,
    'scale-down': disableScaleDown,
    'pause-release': disablePauseRelease,
    'resume-release': disableResumeRelease,
    'update-tf': disableUpdateTf,
    'release-schedule': disableReleaseSchedule,
    'unlock-state': disableUnlockState,
    validations: validationsState,
    'terraform-export': disableTerraformExport,
  };
};

export const getReleasePageActionsStatusMap = ({
  clusterState,
  clusterDetails,
  tfVersionMap,
  pendingMigrationsOverview,
  cpSetting,
}) => {
  const actionOverallStatusMap = {};
  const visibilityMap = getReleasePageVisibility({
    clusterState,
    clusterDetails,
  });
  const disableMap = getDisableStatusForActions({
    clusterState,
    clusterDetails,
    tfVersionMap,
    pendingMigrationsOverview,
    cpSetting,
  });
  Object.entries(visibilityMap)?.forEach(([key, value]) => {
    actionOverallStatusMap[key] = {
      visible: value,
      disable: disableMap[key],
    };
  });
  return actionOverallStatusMap;
};

export const getValidationsAndSevereError = (validations) => {
  const validationsList = validations
    .map((validation) => validation?.errors || [])
    .flat();

  const severeError = validationsList.find(
    (validation) =>
      validation?.severity === 'ERROR' &&
      ['Syntax Error', 'GuardRails Compliance Issues'].includes(
        validation?.category,
      ),
  );

  return { validationsList, severeError };
};
